<div class="header">
    <div class="header-left">
        <button class="back" data-test="dialog-upload-media-back" (click)="goBack()">
            <i class="pi pi-arrow-left"></i>
        </button>
        <h2>{{ title() }}</h2>
    </div>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="dialog-upload-media-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'media.fieldset.basic' | translate }}</h2>
        <app-form-input
            [control]="form.controls.name"
            [label]="'media.form.name' | translate"
            [placeholder]="'media.form.name.placeholder' | translate"
            inputId="name"
            testId="dialog-upload-media-name"
        />
    </div>

    <div class="section">
        <h2>{{ 'media.fieldset.source' | translate }}</h2>
        <div class="col">
            @if (mediaType === 'text') {
                <app-form-wysiwyg
                    [control]="form.controls.content"
                    [label]="'media.form.content' | translate"
                    inputId="content"
                    testId="dialog-upload-media-content"
                />
                <app-form-number
                    [control]="form.controls.duration"
                    [label]="'media.form.duration' | translate"
                    inputId="duration"
                    testId="dialog-upload-media-duration"
                />
            } @else {
                <app-form-file-upload
                    [control]="form.controls.mediaId"
                    [label]="'media.form.file' | translate"
                    [type]="mediaType"
                    [accept]="fileAccept()"
                    inputId="file"
                    testId="dialog-upload-media-file"
                />
            }
        </div>
    </div>
</form>

<div class="footer">
    <p-button [label]="'media.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="dialog-upload-media-cancel" (onClick)="goBack()" />
    <p-button
        type="submit"
        [label]="'dialogs.selectMedia.upload.createAndUse' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="dialog-upload-media-submit"
        (onClick)="onSubmit()"
    />
</div>
